import type React from 'react'
import type { IconProps } from './types'

const CheckIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.975L20.1501 7.4L9.5501 18Z' />
	</svg>
)

export default CheckIcon
